import React, { useState } from 'react';
import ReactTimeAgo from 'react-time-ago';

// react plugin for creating charts
// import ChartistGraph from 'react-chartist';
// @material-ui/core
import { makeStyles } from '@material-ui/core/styles';

// @material-ui/icons
import ClearAll from '@material-ui/icons/ClearAll';
import Add from '@material-ui/icons/Add';
import DateRange from '@material-ui/icons/DateRange';
import Update from '@material-ui/icons/Update';
// import ArrowUpward from '@material-ui/icons/ArrowUpward';
// import AccessTime from '@material-ui/icons/AccessTime';
// import Accessibility from '@material-ui/icons/Accessibility';
import ShowChart from '@material-ui/icons/ShowChart';

// core components
// import { completedTasksChart } from '../../variables/charts';
import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle';
import GridItem from '../../components/Admin/Grid/GridItem';
import GridContainer from '../../components/Admin/Grid/GridContainer';
// import Table from '../../components/Admin/Table/Table';
// import Tasks from '../../components/Admin/Tasks/Tasks';
// import CustomTabs from '../../components/Admin/CustomTabs/CustomTabs';
import Success from '../../components/Admin/Typography/Success';
import Card from '../../components/Admin/Card/Card';
import CardHeader from '../../components/Admin/Card/CardHeader';
import CardIcon from '../../components/Admin/Card/CardIcon';
import CardBody from '../../components/Admin/Card/CardBody';
import CardFooter from '../../components/Admin/Card/CardFooter';
import Primary from '../../components/Admin/Typography/Primary';
import Button from '../../components/Admin/CustomButtons/Button';
import Modal from '../../components/Admin/Modal/Modal';
import { PreLoader } from '../../components';

import useViewer from '../../providers/Customer/useViewer';
import useCustomerRequestNewInvestment from '../../providers/Customer/useCustomerRequestNewInvestment';
import { nairaAmount } from '../../lib/utils';

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const { viewer } = useViewer();
  const { requested, loading, handleSubmit } = useCustomerRequestNewInvestment();
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const InvestButton = () => (
    <a href="#pablo" onClick={() => openModal()}>
      {viewer.investmentBreakdown.count > 0 ? 'Invest More' : 'Invest Now'}
    </a>
  );

  const startDate = new Date(viewer.createdAt);
  return (
    <div>
      {loading && <PreLoader />}
      <GridContainer>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <ShowChart />
              </CardIcon>
              <p className={classes.cardCategory}>Active Investments</p>
              <h3 className={classes.cardTitle}>{nairaAmount(viewer.investmentBreakdown.totalActivePrincipal)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Success>
                  <Add />
                </Success>
                <InvestButton />
                <Modal open={open} closeModal={closeModal}>
                  <Card>
                    <CardBody className="text-center">
                      {!requested && <h4 className="pb-2">Tap here to request for a new Investment with us</h4>}
                      {!requested ? (
                        <Button color="primary" type="submit" disabled={loading} onClick={handleSubmit}>
                          Place Request
                        </Button>
                      ) : (
                        <Primary>
                          <h3>
                            Thank you for indicating interest in investing with us. We will reach out to you shortly.
                          </h3>
                        </Primary>
                      )}
                    </CardBody>
                  </Card>
                </Modal>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="primary" stats icon>
              <CardIcon color="primary">
                <ClearAll />
              </CardIcon>
              <p className={classes.cardCategory}>Active ROI</p>
              <h3 className={classes.cardTitle}>{nairaAmount(viewer.investmentBreakdown.totalActiveROI)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                <ReactTimeAgo date={startDate} timeStyle="time" />
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <ShowChart />
              </CardIcon>
              <p className={classes.cardCategory}>Total Investments</p>
              <h3 className={classes.cardTitle}>{nairaAmount(viewer.investmentBreakdown.totalInvestedPrincipal)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Success>
                  <Add />
                </Success>
                <InvestButton />
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <ClearAll />
              </CardIcon>
              <p className={classes.cardCategory}>ROI</p>
              <h3 className={classes.cardTitle}>{nairaAmount(viewer.investmentBreakdown.totalROI)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Just Updated
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        {/* <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Portfolio Growth</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{' '}
                <ReactTimeAgo date={startDate} timeStyle="time" />
              </p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated 4 minutes ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
        {/* <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Email Subscriptions</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
        {/* <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Tasks</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
      </GridContainer>
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomTabs
            title="Tasks:"
            headerColor="primary"
            tabs={[
              {
                tabName: 'Bugs',
                tabIcon: BugReport,
                tabContent: <Tasks checkedIndexes={[0, 3]} tasksIndexes={[0, 1, 2, 3]} tasks={bugs} />,
              },
              {
                tabName: 'Website',
                tabIcon: Code,
                tabContent: <Tasks checkedIndexes={[0]} tasksIndexes={[0, 1]} tasks={website} />,
              },
              {
                tabName: 'Server',
                tabIcon: Cloud,
                tabContent: <Tasks checkedIndexes={[1]} tasksIndexes={[0, 1, 2]} tasks={server} />,
              },
            ]}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Employees Stats</h4>
              <p className={classes.cardCategoryWhite}>New employees on 15th September, 2016</p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={['ID', 'Name', 'Salary', 'Country']}
                tableData={[
                  ['1', 'Dakota Rice', '$36,738', 'Niger'],
                  ['2', 'Minerva Hooper', '$23,789', 'Curaçao'],
                  ['3', 'Sage Rodriguez', '$56,142', 'Netherlands'],
                  ['4', 'Philip Chaney', '$38,735', 'Korea, South'],
                ]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer> */}
    </div>
  );
}
